export default class MitMapLockService {
    static async acquireLock(buildingId, forceOverride = false) {
        const response = await fetch('/api/v2/manager/spaces/lock', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ buildingId, forceOverride })
        });

        const data = await response.json();
        
        if (!response.ok) {
            if (response.status === 423) {
                return { locked: true, ...data }; // Inform UI to show prompt
            }
            throw new Error(data.message || 'Failed to acquire lock');
        }
        return { locked: false, success: true };
    }

    static async releaseLock(buildingId) {
        if (!buildingId) return;
        await fetch(`/api/v2/manager/spaces/lock/${buildingId}`, { 
            method: 'DELETE' 
        }).catch(err => console.error("Failed to release lock:", err));
    }
}